<template>
    <add-edit-designation></add-edit-designation>
</template>

<script>
import AddEditDesignation from "@/layouts/components/masters/designation/addedit-designation.vue";
export default {
 components : {
   AddEditDesignation
 },
};
</script>